class MatrixInstance {
  constructor(a, b, c, d, e, f) {
    this.a = a
    this.b = b
    this.c = c
    this.d = d
    this.e = e
    this.f = f
  }

  multiply(matrix) {
    const { a, b, c, d, e, f } = this
    const { a: g, b: h, c: i, d: j, e: k, f: l } = matrix
    return new MatrixInstance(
      a*g + c*h,
      b*g + d*h,
      a*i + c*j,
      b*i + d*j,
      a*k + c*l + e,
      b*k + d*l + f,
    )
  }

  translate(dx, dy) {
    const { a, b, c, d, e, f } = this
    return new MatrixInstance(
      a, b, c, d,
      a*dx + c*dy + e,
      b*dx + d*dy + f,
    )
  }

  scale(w, h) {
    const { a, b, c, d, e, f } = this
    return new MatrixInstance(a*w, b*w, c*h, d*h, e, f)
  }

  rotate(theta) {
    const { a, b, c, d, e, f } = this
    const g = theta === 0 ? 1 : Math.cos(theta)
    const h = theta === 0 ? 0 : Math.sin(theta)
    const i = -h
    const j = g
    return new MatrixInstance(
      a*g + c*h,
      b*g + d*h,
      a*i + c*j,
      b*i + d*j,
      e, f
    )
  }

  transformPoint({ x, y }) {
    const { a, b, c, d, e, f } = this
    return {
      x: a*x + c*y + e,
      y: b*x + d*y + f,
    }
  }

  inverse() {
    const { a, b, c, d, e, f } = this
    let det = a * d - b * c
    if (det === 0) {
      // Technically this matrix is non-invertible, but that's not useful.
      // Pretend the determinant isn't *quite* zero. In practice we hit this
      // condition when the scaling transform turns a shape into a vertical
      // line (i.e. scaleX = 0; left and right handle have the same x)
      //
      // Transposition may be another way to do many of the things I'm using
      // matrix inversion for today.
      det = 1e-100
    }
    const invDet = 1 / det
    return new MatrixInstance(
      d * invDet,
      -b * invDet,
      -c * invDet,
      a * invDet,
      (c * f - d * e) * invDet,
      (b * e - a * f) * invDet
    )
  }

  toArray() {
    const { a, b, c, d, e, f } = this
    return [a, b, c, d, e, f]
  }
}

function TransformMatrix2D(a = 1, b = 0, c = 0, d = 1, e = 0, f = 0) {
  return new MatrixInstance(a, b, c, d, e, f)
}

TransformMatrix2D.fromArray = function([a, b, c, d, e, f]) {
  return TransformMatrix2D(a, b, c, d, e, f)
}
TransformMatrix2D.fromMatrix = function({ a, b, c, d, e, f }) {
  return TransformMatrix2D(a, b, c, d, e, f)
}

module.exports = { TransformMatrix2D }
